export const groupStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  padding: '12px 0',
  borderBottom: ({ palette }) => `1px solid ${palette.border.default}`,
};

export const metaStyles = {
  color: 'text.secondary',
};

export const affectedToggleStyles = {
  alignSelf: 'flex-start',
  gap: '4px',
  padding: '2px 4px',
  minWidth: 0,
  color: ({ palette }) => palette.text.link,
  textTransform: 'none',
};

export const affectedListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  marginLeft: '24px',
  paddingLeft: '12px',
  borderLeft: ({ palette }) => `2px solid ${palette.border.default}`,
};
